import React, { useEffect, useState } from "react";
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid
} from "@material-ui/core";

import TopSpacer from "../../../components/Common/spacer/TopSpacer";
import Breadcrums from "../../../components/BreadCrums/breadcrums";

import SearchGrid from "../../../components/table/SearchGrid";

import useStyles from "./styles";

//import CustomerOne from "../../assets/img/shop/customerOne.svg";
//import CustomerTwo from "../../assets/img/shop/customerTwo.svg";
//import Stopwatch from "../../assets/img/icons/stopwatch.svg";

import { withSnackbar } from "../../../components/Message/Alert";

import { useHistory } from "react-router-dom";
import { PostDataAPI } from '../../../Services/APIService';
import UserPlaceholder from "../../../assets/img/userPlaceholder.svg";
import { formateMdnNumber, getFormatedDate, formatDate, formatDateTime, numberDisplay } from '../../../../src/components/Common/Extensions';
import Loader from "../../../components/Loader/Loader";
import PrintDonationReciept from './print/PrintDonation';
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import ClearIcon from '@material-ui/icons/Clear';
import SuccessIcon from "../../../assets/img/icons/DonationSuccessful.svg";
import FailedIcon from "../../../assets/img/icons/DonationFailed.svg";
import GiftIcon from "../../../assets/img/icons/GiftIcon.png";
import CreateShippingLabel from '../../orderTracking/domesticTracking/createShippingLabel/CreateShippingLabel';
import ViewPrint from '../../orderTracking/domesticTracking/viewPrint/ViewPrint';
import StatusSummary from '../../orderTracking/domesticTracking/statusSummary/StatusSummary';

function Payment({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    let history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [donationsPaid, setDonationsPaid] = useState([]);
    const [filteredDonationsPaidData, setFilteredDonationsPaidData] = useState([]);
    const [filteredStatus, setFilteredStatus] = useState([]);
    const [viewReceiptHtml, setViewReceiptHtml] = useState('');
    const [viewPrintDonationReceipt, setViewPrintDonationReceipt] = useState(false);

    const [donationInfo, setDonationInfo] = useState({});
    const [trackLabelImage, setTrackImageLabel] = useState('');
    const [trackingType, setTrackingType] = useState('domesticTracking');
    const [donationId, setDonationId] = useState();
    const [shippingLabelDialog, setShippingLabelDialog] = useState(false);

    const closeShippinglabelDialog = () => {
        setShippingLabelDialog(false);
    }

    const [viewShipmentLabelPrint, setViewShipmentLabelPrint] = useState(false);
    const openShipmentLabelPrintDialog = () => {
        setViewShipmentLabelPrint(true)
    }
    const closeShipmentLabelPrintDialog = () => {
        setViewShipmentLabelPrint(false)
    }

    const handleSuccessClose = (message) => {
        setDonationInfo({});
        closeShippinglabelDialog();
        statusDialogSummaryClose();
        closeShipmentLabelPrintDialog();
        showMessage("Success", message, "success", 3000);
        loadDontationDetails();
    }

    const openViewPrintDialog = () => {
        setViewPrintDonationReceipt(true)
    }
    const closeViewPrintDialog = () => {
        setViewPrintDonationReceipt(false)
    }

    const [statusDialogSummary, setStatusDialogSummary] = useState(false);

    const statusDialogSummaryClose = () => {
        setStatusDialogSummary(false)
    }

    const statusDialogSummaryOpen = () => {
        setStatusDialogSummary(true)
    }
    const donationStatusBoxes = [
        {
            value: 'Successful',
            transactionStatus: 'Success',
            numbers: '00',
            icon: SuccessIcon,
        },
        {
            value: 'Failed',
            transactionStatus: 'Error',
            numbers: '00',
            icon: FailedIcon,
        },
        {
            value: 'Gifts Sent',
            transactionStatus: 'Gifted',
            numbers: '00',
            icon: GiftIcon,
        }

    ]

    const handleStatusClick = (event, transactionStatus) => {
        var lstStatus = filteredStatus;
        if (event.target.checked) {
            lstStatus.push(transactionStatus);
        }
        else {
            lstStatus = lstStatus.filter(s => s != transactionStatus)
        }
        setFilteredStatus(lstStatus);
        if (lstStatus.length > 0) {
            setFilteredDonationsPaidData(donationsPaid.filter(o => lstStatus.some(s => s == o.transactionStatus)));
            let lstFiltDonations = [];
            if (lstStatus.length > 0) {
                for (var i = 0; i < lstStatus.length; i++) {
                    let invStatus = lstStatus[i];
                    let lstResult = [];
                    switch (invStatus) {
                        case 'Gifted':
                            lstResult = donationsPaid.filter(t => t.trackingNumber != null);
                            break;
                        case 'Success':
                            lstResult = donationsPaid.filter(t => t.transactionStatus == 'Success');
                            break;
                        case 'Error':
                            lstResult = donationsPaid.filter(t => t.transactionStatus == 'Error');
                            break;
                    }
                    lstFiltDonations.push(...lstResult)
                }
            }
            // Convert the data array into a Set to remove duplicates
            const uniqueSet = new Set(lstFiltDonations);
            // Convert the Set back to an array
            const uniqueArray = Array.from(uniqueSet);
            setFilteredDonationsPaidData(uniqueArray);
        }
        else {
            setFilteredDonationsPaidData(donationsPaid);
        }

        handleDataRefresh();
    }


    const [searchFilter, setValue] = useState('');
    const handleClearInput = (name) => {
        setValue('')
        loadDontationDetails();
    };
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataRefresh()
        }
    }
    const [isDataRefresh, setIsDataRefresh] = useState(false);

    const handleDataRefresh = () => {
        setIsDataRefresh(!isDataRefresh);
    }

    const loadDontationDetails = () => {
        setIsLoading(true)
        PostDataAPI("payments/loadECCPDonationsGrid").then((result) => {
            setIsLoading(false)
            console.log(result.data);
            if (result.success && result.data != null) {
                console.log(result.data)
                var record = result.data.map((item, i) => {
                    item.giftSent = item.trackingNumber ? <CardGiftcardIcon className="GiftIcon" /> : ''
                    item.fullName = item.firstName + ' ' + item.lastName;
                    item.formatedPhone = formateMdnNumber(item.phone);
                    item.emailAddress = item.email;
                    item.paidAmount = '$' + numberDisplay(item.amount, 2, 2, 0);
                    item.completeAddress = item.address + " " + item.city + ', ' + item.state + ' ' + item.zip;
                    item.fullName = item.firstName ? item.firstName + ' ' + item.lastName : '';
                    item.createDate = formatDateTime(item.createDate);
                    item.paymentGateway = item.paymentGateway ? item.paymentGateway : 'Converge';
                    item.transactionStatus = (item.transactionStatus == ''
                        || item.transactionStatus == 'active'
                        || item.transactionStatus == 'succeeded'
                        || item.transactionStatus == 'sucess'
                    ) ? 'Success' : 'Error';
                    return { ...item };
                })
                setDonationsPaid(record);
                setFilteredDonationsPaidData(record);

            }
            handleDataRefresh();
        })
    }

    const handleActionClick = (key, item) => {
        if (key == 'sendGift') {
            //open create shipping label dialog
            var params = {
                attentionTo: item.firstName.trim() + (item.lastName ? ' ' + item.lastName : ''),
                emailAddress: item.email,
                phone: item.phone,
                address1: item.address,
                city: item.city,
                state: item.state,
                zipCode: item.zip
            }
            setDonationInfo(params)
            setDonationId(item.paymentId);
            setShippingLabelDialog(true);
        } else if (key == 'printLabel') {
            //print label dialog
            handlePrintShippingLabel(item);
        } else if (key == 'printReceipt') {
            handlePrintReceiptAction(item)
        } else if (key == 'summary') {
            setDonationInfo(item)
            setStatusDialogSummary(true);

        }

    }

    const handlePrintShippingLabel = (item) => {
        if (item.graphicImage && item.graphicImage.length > 0) {
            setDonationInfo(item)
            setViewShipmentLabelPrint(true)
        } else {
            if (item.status == 'D') {
                showMessage("Error", "Label is unavailable -- all the packages of the shipment have been sent to the destination address", "error", 3000);
            } else {
                showMessage("Error", "Label is unavailable", "error", 3000);
            }
        }
    }

    const handlePrintReceiptAction = (item) => {
        item.createDate = new Date(item.createDate);
        item.trackingId = item.trackingId ? item.trackingId : 0;
        item.type = 'eccp'
        setIsLoading(true);
        PostDataAPI("payments/printPaymentReceipt", item).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                setViewReceiptHtml(result.data);
                openViewPrintDialog();
            }
        })
    }

    const exportRecord = () => {
        const paymentIds = filteredDonationsPaidData.map(item => item.paymentId);
        setIsLoading(true);
        PostDataAPI("payments/exportDonationsToExcel", paymentIds).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                window.location.assign("." + result.data);
            } else {

            }
        })
    }

    const getHeaderCount = (status) => {
        var count = 0;
        if (status == 'Success') {
            count = donationsPaid?.filter(t => t.transactionStatus == 'Success').length
        } else if (status == 'Error') {
            count = donationsPaid?.filter(t => t.transactionStatus == 'Error').length
        } else if (status == 'Gifted') {
            count = donationsPaid?.filter(t => t.trackingNumber != null).length
        }
        return count;
    }

    useEffect(() => {
        loadDontationDetails();
    }, []);
    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Every Child Christmas"} isBack={false} currentLink={'Donations'}></Breadcrums>
                    </Grid>
                </Grid>
                <div className={classes.rightHeader}>

                </div>
            </div>

            <Grid container row className={classes.container}>

                <div className={classes.statusBoxContainer}>
                    {donationStatusBoxes.map((item, i) => (
                        <>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        onClick={(e) => { handleStatusClick(e, item.transactionStatus) }}
                                    />
                                }
                                label={<>
                                    <div className={item.transactionStatus == "Success" ? classes.statusBoxes + " " + "Submitted" :
                                        item.transactionStatus == "Error" ? classes.statusBoxes + " " + "EmailOpened" :
                                            item.transactionStatus == "Gifted" ? classes.statusBoxes + " " + "Gifted" :
                                                ''
                                    }>

                                        <div className={classes.statusBoxContent}>
                                            <img src={item.icon} width="70px" />
                                            <h2 style={{ marginTop: '6px' }}>{getHeaderCount(item.transactionStatus)}</h2>
                                            <h5>{item.value} </h5>
                                        </div>


                                    </div>
                                </>}
                            />
                        </>
                    ))}

                </div>

            </Grid>

            <Grid container className={classes.gridHeader}>

                <div item className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={loadDontationDetails}>Refresh</Button>
                    <Button className={classes.changeBtn} onClick={exportRecord}>Export</Button>
                </div>

                <div itemclassName={classes.gridActions}>
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                    />

                </div>
            </Grid>


            <Grid row className={classes.container}>
                <SearchGrid
                    columns="donationsPaid"
                    list={filteredDonationsPaidData}
                    filter={searchFilter}
                    noRecordMsg="No record exists."
                    Icon={true}
                    isUpdate={isDataRefresh}
                    isSearchAble={false}
                    onActionClick={handleActionClick}
                />
            </Grid>

            {viewPrintDonationReceipt ?
                <PrintDonationReciept
                    dialogOpenClose={viewPrintDonationReceipt}
                    handleClose={closeViewPrintDialog}
                    htmlContent={viewReceiptHtml}
                >

                </PrintDonationReciept>
                : ''}

            {shippingLabelDialog ?
                <CreateShippingLabel
                    dialogOpenClose={shippingLabelDialog}
                    handleClose={closeShippinglabelDialog}
                    trackNumberDetails={donationInfo}
                    trackingType={trackingType}
                    handleSuccessClose={handleSuccessClose}
                    donationId={donationId}
                ></CreateShippingLabel>
                :
                ''}

            {viewShipmentLabelPrint ?
                <ViewPrint
                    dialogOpenClose={viewShipmentLabelPrint}
                    handleClose={closeShipmentLabelPrintDialog}
                    trackNumberDetails={donationInfo} >

                </ViewPrint>
                : ''}
            {statusDialogSummary ?
                <StatusSummary
                    dialogOpenClose={statusDialogSummaryOpen}
                    handleClose={statusDialogSummaryClose}
                    trackNumberDetails={donationInfo}
                >
                </StatusSummary>
                : ''
            }
        </>
    )
}
export default withSnackbar(Payment);